/**
 * Shared regex markers for copyright registration / deposit metadata in catalog text fields.
 * Used by search filtering (full haystack) and detail-page note splitting (per line).
 */
export const CREATIVE_WORKS_RECORD_TEXT_PATTERNS = [
  /^copyright\s+by:/i,
  /^copyright\s+no\.?:/i,
  /^transfer\b.*\bcopyright\s+office\b/i,
  /\bu\.s\.\s*copyright\s+office\b/i,
  /\bearly\s+copyright\s+records?\b/i,
  /^forms\s+part\s+of\s+the\s+early\s+copyright\s+records\b/i,
  /\bcopyright\s+claim\b/i,
  /\bregistered\s+in\s+the\s+u\.s\.\s+district\s+courts?\s+for\s+copyright\b/i,
] as const;

export const matchesCreativeWorksRecordText = (text: string): boolean =>
  CREATIVE_WORKS_RECORD_TEXT_PATTERNS.some((pattern) => pattern.test(text));
